import { render, staticRenderFns } from "./RankEdit.vue?vue&type=template&id=510897ea"
import script from "./RankEdit.vue?vue&type=script&lang=js"
export * from "./RankEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports